import {Component, computed, EventEmitter, inject, Input, OnInit, Output, signal} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {environment} from "projects/store/src/environments/environment";
import {UtilService, CustomMessageService, OriginMessageError} from "library";
import {UserValidatorService} from "projects/store/src/app/services/api/v1/user-validator.service";
import {ActivatedRoute} from "@angular/router";
import {filter, take} from "rxjs/operators";

@Component({
  selector: 'app-sales-additional-information-field-contact',
  templateUrl: './sales-additional-information-field-contact.component.html',
})
export class SalesAdditionalInformationFieldContactComponent implements  OnInit{
  country: any = environment.global.country;

  @Input({required: true} ) form!: FormGroup;
  @Input({required: true} ) field: any;
  @Output() saveEvent = new EventEmitter();
  isSubmitted = signal(false);
  utilService = inject(UtilService);
  isAndroidDevice!: boolean;
  requestId!: string

  userValidatorService = inject(UserValidatorService);
  private readonly route = inject(ActivatedRoute);
  private readonly customMessageService  = inject(CustomMessageService);

  ngOnInit() {
    this.requestId = this.route.snapshot.params['request_id'];
    console.log(this.requestId);
    this.isAndroidDevice = this.utilService.detectDevice();
    this.form.addControl( 'nombre' , new FormControl('', [Validators.required]));
    this.form.addControl( 'telefono' , new FormControl('', {
      validators: [Validators.required],
      asyncValidators: [this.userValidatorService.phoneServiceVerification(), this.userValidatorService.phoneServiceExistValidator(this.requestId, this.field.key)],
      updateOn: 'blur'
    }));
    this.patchForm();
  }

  onGenerateDataToSave() {
    this.isSubmitted.set(true);

    const nombre = this.form.get('nombre');
    const telefono = this.form.get('telefono');


    nombre?.markAsTouched();
    telefono?.markAsTouched();
    nombre?.updateValueAndValidity({ onlySelf: true, emitEvent: true });
    telefono?.updateValueAndValidity({ onlySelf: true, emitEvent: true });

    if (nombre?.pending || telefono?.pending) {
      this.form.statusChanges
        .pipe(
          filter(status => status !== 'PENDING'),
          take(1)
        )
        .subscribe(() => {
          if (nombre?.valid && telefono?.valid) {
            this.emitSaveData();
          }
        });
    } else {
      if (nombre?.valid && telefono?.valid) {
        this.emitSaveData();
      }
    }
  }


  private emitSaveData() {
    const data = {
      id: this.field.id,
      value: JSON.stringify({
        nombre: this.form.get('nombre')?.value,
        telefono: this.form.get('telefono')?.value
      })
    };

    this.saveEvent.emit(data);

  }

  patchForm(){
    if (!this.field?.value) {
      return;
    }

    const value = JSON.parse(this.field.value);
    this.form.patchValue({...value});
  }

  async pickContacts() {
    if ('contacts' in navigator && 'ContactsManager' in window) {
      try {
        const props = ['name', 'tel'];
        const opts = { multiple: false };
        const contacts = await (navigator as any).contacts.select(props, opts);

        if (contacts.length > 0) {
          this.form.patchValue({
            nombre: contacts[0].name ,
            telefono: contacts[0].tel
          });
        }

        this.onGenerateDataToSave();

      } catch (error) {
        this.customMessageService.logErrorOnly({ message: 'Error al seleccionar contacto', error: error}, OriginMessageError.FRONTEND);
      }
    }
  }

  removeContacts(){
    this.form.patchValue({
      nombre: '',
      telefono: ''
    });
    console.log("Remover contacto");
  }

  addManualPersonalReference(){
    this.isAndroidDevice = false;
  }

  get f(){
    return this.form.controls;
  }

}
